import { Box, styled } from '@lingoda/ui';
import bgSignup from './bg-signup.svg?url';
import type React from 'react';

type Props = React.PropsWithChildren<unknown>;

export const Wrapper = ({ children }: Props) => {
    return (
        <WrapperStyled>
            <BackgroundPanel />
            <ContainerStyled>{children}</ContainerStyled>
        </WrapperStyled>
    );
};

const WrapperStyled = styled(Box)(({ theme }) => {
    return {
        display: 'grid',
        flexGrow: '1',
        width: '100%',
        alignItems: 'flex-start',
        paddingTop: `clamp(${theme.spacing(5)}, 10vh, ${theme.spacing(10)})`,
        paddingBottom: 0,
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            alignItems: 'flex-start',
            paddingBlock: 0,
        },
    };
});

const ContainerStyled = styled(Box)(({ theme }) => {
    return {
        boxSizing: 'border-box',
        margin: '0 auto',
        padding: '0 32px',
        width: '100%',
        zIndex: '1',
        maxWidth: 1364,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        [theme.breakpoints.down('xl')]: { maxWidth: 1164 },
        [theme.breakpoints.down('lg')]: { maxWidth: 994 },
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            alignItems: 'center',
            gap: '32px',
            padding: 0,
            paddingTop: theme.spacing(5),
            maxWidth: 748,
        },
        [theme.breakpoints.down(767)]: { maxWidth: 540 },
    };
});

const BackgroundPanel = styled('div')(({ theme }) => {
    return {
        position: 'absolute',
        top: -2,
        left: 0,
        bottom: 0,
        width: '50%',
        backgroundColor: theme.colors.brand.plum,
        backgroundImage: `url(${bgSignup})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        backgroundRepeat: 'no-repeat',
        zIndex: 0,
        [theme.breakpoints.down('md')]: {
            top: 0,
            width: '100%',
        },
    };
});
